import axios from "axios";

const baseUrl = `${process.env.REACT_APP_BACKEND_HOST}`;

const readLogVisitor = async (param) => {
  const { data } = await axios.get(`${baseUrl}/queryLog/visitor`, {
    params: param,
  });
  return data;
};

/**
 *
 * @param param
 * startDate, endDate, queryList
 * @returns {Promise<never>}
 */
const orderStatisticsTogether = async (param) => {
  const { data } = await axios.get(`${baseUrl}/userOrder/together/readStatus`, {
    params: param,
  });
  return data;
};

const orderStatistics = async (param) => {
  const { data } = await axios.get(`${baseUrl}/userOrder/statistics`, {
    params: param,
  });
  return data;
};

/**
 * 매출액, 판매건수
 * @param param
 * startDate, endDate, query
 * @returns {Promise<never>}
 */
const queryLogByInfluencer = async (param) => {
  const { data } = await axios.get(`${baseUrl}/queryLog/byInfluencer`, {
    params: param,
  });
  return data;
};

const readReview = async (param) => {
  const { data } = await axios.get(`${baseUrl}/userReviewHistory/plutus/list`, {
    params: param,
  });
  return data;
};

const DashboardApi = {
  orderStatisticsTogether,
  orderStatistics,
  queryLogByInfluencer,
  readLogVisitor,
  readReview,
};

export default DashboardApi;
